import axios from '@/static/js/request'
import { getformData } from '@/static/js/zjs'
import store from '@/store'

// 获取静默授权之后的跳转链接
export const getRedirectUrl = function() {
  return axios.get(`/cms/weixin/oauth2`, {
    params: {
      url: location.href
    }
  })
}

// 获取非静默授权之后的跳转链接
export const getRedirectSnsapiUrl = function() {
  return axios.get(`/cms/weixin/snsapi/userinfo/url`, {
    params: {
      url: location.href,
      state: 'no'
    }
  })
}

// 根据页面code，拉取用户信息(非静默)
export const getUserInfoByCodeSnsapi = function({ code }) {
  return axios.get('/cms/weixin/snsapi/userinfo', {
    params: {
      code
    }
  })
}
// 根据页面code，获取openid
export const getOpenidByCode = function({ code }) {
  return axios.get('/cms/weixin/openid', {
    params: {
      code
    }
  })
}

// 获取微信jssdk
export const getJsSignature = function() {
  return axios.get('/cms/weixin/hw/getJsSignature', {
    params: {
      url: location.href
    }
  })
}

// 根据页面openid，获取用户信息
export const getUserInfoByOpenid = function({ openid }) {
  return axios.post(`/cms/weixin/hw/getUserInfoByOpenid?openid=${openid}`)
}

// 根据页面openid，用户选择年级版本
export const getUserPreferences = function({ openid }) {
  return axios.post(`/cms/weixin/hw/getUserPreferences?openid=${openid}`)
}

// 根据页面openid，用户微信信息
export const getUser = function({ openid }) {
  return axios.get(`/cms/weixin/user?openid=${openid}`)
}

// 根据页面openid，获取用户中基础信息
export const getUserBasicInfo = function({ openid }) {
  return axios.post(`/cms/weixin/usercenter/basicInfo?openid=${openid}`)
}

// 更新用户班级、年级、教材版本
export const modifyClassGrade = function({ openid, userPrefString, clearVersion = 0 }) {
  return axios.post(
    '/cms/weixin/hw/saveUserPreferences',
    getformData({
      openid,
      userPref: userPrefString,
      clearVersion
    })
  )
}

// 选择身份
export const saveUserType = function({ openid, userType }) {
  return axios.post(`/cms/weixin/user/saveUserType?openid=${openid}&userType=${userType}`)
}

// 领取家长锁福利
export const getLock = function({ openid }) {
  return axios.post(`/cms/weixin/user/getLock?openid=${openid}`)
}
// 获取用户家长锁状态，只返回状态，不校验过期时间
export function getParentLockState(data) {
  return axios.post('/cms/weixin/user/getParentLockState', getformData(data))
}
// 获取机构用户
export function getStoreUserPerm(data) {
  return axios.get(`/cms/weixin/store/common/api/user/permission/${data.openid}`)
}
export function saveUserPref(data) {
  return axios.post(
    '/cms/weixin/hw/saveUserPreferences',
    getformData({
      openid: data.openid,
      userPref: data.userPref
    }),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}
export function getBuyBooks(data) {
  return axios.post(
    '/cms/weixin/wb/findUserWorkbookByOpenid',
    getformData({
      openid: data.openid
    })
  )
}
// 更新用户的treasureBox字段
export function updateTreasureBox(data) {
  const { openid, isHave = 'Y', keyName } = data
  if (!keyName) return
  return axios
    .post(
      '/cms/weixin/user/updateTreasureBox',
      getformData({
        openid: openid || store.state.user.openid,
        isHave: isHave,
        treasureBox: keyName
      })
    )
    .then((res) => {
      if (res.data.code === 200) {
        store.commit('user/setUserInfo', res.data.squareUserInfo)
      }
      return res.data.squareUserInfo
    })
}
